import PaginationComponent from "components/pagination/Pagination";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import pendingReq from "../../../../../assets/img/icons/customIcons/filter.svg";
import { Row, Col } from "reactstrap";
import SearchIcon from "../../../../../assets/img/icons/customIcons/searchicondark.svg";

import CompanyPendingRequestcard from "./CompanyPendingRequestcard";
import { getCompanyBookingPendingInfo } from "redux/actions/admin/BookingPendingRequestAction";
import CustomFilter from "components/customFilter";

function CompanyPendingRequestList({
  handleEmployeeSearchOnChange,
  handleSearch,
  searchFormData,
  isDashboard,
  data,
  handleClearDate,
  list,
  toggle,
  handleSearchOnSelect,
}) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [showToggle, setShowToggle] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tableHeight, setTableHeigth] = useState(300);

  const pendingCompnayRequestList = useSelector(
    (state) => state.BookingPendingReducer.result
  );
  const pendingCompnayRequestListLoader = useSelector(
    (state) => state.BookingPendingReducer.loader
  );

  useEffect(() => {
    setTitle(data);

    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  // const clearDate = () => {
  //   const data = { ...searchFormData, fromDate: null, toDate: null };
  //   dispatch(getCompanyBookingPendingInfo("0", "1", data, ""));
  // };

  const handlePagination = (tab) => {
    const finalData = {
      ...searchFormData,
      page: tab,
    };

    dispatch(getCompanyBookingPendingInfo("0", "1", finalData, ""));
  };

  // eslint-disable-next-line
  useEffect(() => {
    const divElement = document.getElementById("tableDiv");
    if (pendingCompnayRequestList?.pages?.length > 1) {
      setTableHeigth(divElement.scrollHeight - 72 + "px");
    } else {
      setTableHeigth(divElement.scrollHeight - 12 + "px");
    }
  });

  return (
    <div className="d-flex">
      <Col id="tableDiv" md={isFilter ? "9" : "12"}>
        <Row className="mb-2 second-search">
          <Col md="10">
            <h3 className="tab-title">
              {`${title} (${
                pendingCompnayRequestList?.itemCount
                  ? pendingCompnayRequestList?.itemCount
                  : "0"
              })`}{" "}
            </h3>
          </Col>

          <Col md="2" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="common-outer-filter">
              {list && (
                <div className="btn-group new-cutom-filter  ">
                  <button
                    type="button"
                    onClick={() => {
                      setShowToggle(!showToggle);
                    }}
                    className={"btn dropdown-toggle mr-3"}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img alt="" src={pendingReq} width={"18px"} />
                  </button>
                  <div className="dropdown-menu dropdown-menu-right py-0">
                    {list?.map((item, key) => (
                      <button
                        key={key}
                        className="dropdown-item"
                        onClick={() => toggle(item?.tabId)}
                        type="button"
                        style={{
                          backgroundColor:
                            item?.tabId === "1" ? "#5e72e4" : "none",
                          color: item?.tabId === "1" ? "white" : "none",
                        }}
                      >
                        {item?.title}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {!isDashboard && (
              <div className="common-outer-filter">
                <div className="btn-group new-cutom-filter ">
                  <button
                    type="button"
                    onClick={() => setIsFilter(!isFilter)}
                    className={"btn dropdown-toggle mr-3"}
                  >
                    <img alt="" src={SearchIcon} width={"18px"} />
                  </button>
                </div>
              </div>
            )}
          </Col>
        </Row>

        <CompanyPendingRequestcard loader={pendingCompnayRequestListLoader} />

        <div
          style={{
            display: pendingCompnayRequestListLoader ? "none" : "contents",
          }}
        >
          <PaginationComponent
            totalCount={pendingCompnayRequestList?.itemCount}
            handlePagination={handlePagination}
            activePage={pendingCompnayRequestList?.activePage}
          />
        </div>
      </Col>
      {!isDashboard && (
        <Col
          md="3"
          style={{
            height: tableHeight,
            minHeight: "670px",
            display: isFilter ? "block" : "none",
          }}
        >
          <CustomFilter
            tableHeight={tableHeight}
            minHeight={"670px"}
            handleSearchOnSelect={handleSearchOnSelect}
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleEmployeeSearchOnChange}
            type="inbound"
            list={list}
            isFilter={isFilter}
            setIsFilter={setIsFilter}
            handleClearDate={handleClearDate}
          />
        </Col>
      )}
    </div>
  );
}

export default CompanyPendingRequestList;
